<template>
  <div>
    <v-card outlined>
      <template v-if="!isEmbedded">
        <v-card-title>
          {{ poll.title }}
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            <v-icon class="mr-2">{{ icons.mdiCalendarToday }}</v-icon>
            {{ $t("Vastausaika päättyy") }} {{ getDateTime(poll.expire_date) }}
          </div>
          <div class="mb-3">
            <v-icon class="mr-2">{{ icons.mdiAccountGroupOutline }}</v-icon>
            {{ poll.group_name }}
          </div>
          <div class="mb-3" v-if="poll.anonymous">
            <v-icon class="mr-2">{{ icons.mdiEyeOffOutline }}</v-icon>
            {{ $t("Vastaukset kerätään anonyymisti") }}
          </div>
          <div class="mb-3" v-else>
            <v-icon class="mr-2">{{ icons.mdiEyeOutline }}</v-icon>
            {{ $t("Vastauksiin liitetään nimi automaattisesti") }}
          </div>
          <div class="mb-3" v-if="poll.allow_multiple_answers">
            <v-icon class="mr-2">{{ icons.mdiRestart }}</v-icon>
            {{ $t("Kyselyyn voi vastata useita kertoja") }}
          </div>
          <div v-html="markdownToHtml(poll.description)"></div>
          <br>
          <v-divider></v-divider>
        </v-card-text>
      </template>
      <template v-if="!answered">
        <v-card-text>
          <template v-if="isEmbedded">
            <div class="mb-3">
              <v-icon class="mr-2">{{ icons.mdiCalendarToday }}</v-icon>
              {{ $t("Vastausaika päättyy") }} {{ getDateTime(poll.expire_date) }}
            </div>
            <div class="mb-3" v-if="poll.anonymous">
              <v-icon class="mr-2">{{ icons.mdiEyeOffOutline }}</v-icon>
              {{ $t("Vastaukset kerätään anonyymisti") }}
            </div>
            <div class="mb-3" v-else>
              <v-icon class="mr-2">{{ icons.mdiEyeOutline }}</v-icon>
              {{ $t("Vastauksiin liitetään nimi automaattisesti") }}
            </div>
            <div class="mb-3" v-if="poll.allow_multiple_answers">
              <v-icon class="mr-2">{{ icons.mdiRestart }}</v-icon>
              {{ $t("Kyselyyn voi vastata useita kertoja") }}
            </div>
          </template>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <div v-for="question in questions" :key="question.question.id" class="mb-5">
              <h3 class="mb-1">
                {{ question.question.question }}
              </h3>
              <template v-if="question.question.question_type == 1">
                <v-radio-group class="ma-0 mb-2" hide-details="auto" v-model="question.answer" required
                  :rules="question_rules">
                  <v-radio v-for="option in question.question.question_options" :key="option.id" :value="option.id"
                    :label="option.title"></v-radio>
                </v-radio-group>
              </template>
              <template v-else>
                <v-textarea outlined hide-details="auto" :label="$t('Kirjoita vastaus')" v-model="question.answer"
                  required :rules="question_rules">
                </v-textarea>
              </template>
            </div>
            <br />
            <v-btn color="primary" type="submit"> {{ $t("Lähetä") }} </v-btn>
            <br />
          </v-form>
        </v-card-text>
      </template>
      <template v-else>
        <v-card>
          <v-card-text>
            <v-alert text type="success">
              {{ $t("Olet vastannut kyselyyn") }}
            </v-alert>
          </v-card-text>
        </v-card>
      </template>
    </v-card>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import useMarkdown from "@/@core/utils/useMarkdown";
import api from "@/api";
import { mdiEyeOffOutline, mdiEyeOutline, mdiCalendarToday, mdiAccountGroupOutline, mdiRestart } from "@mdi/js";
import { getDateTime } from "@/@core/utils/datetime_helpers";

export default {
  props: ["poll", "answered", "isEmbedded"],
  setup(props, context) {

    const form = ref(null);
    const question_rules = [(v) => !!v || "Vastaa tähän kysymykseen"];
    const { markdownToHtml } = useMarkdown();

    const submit = async () => {
      if (form.value.validate()) {
        let payload = {
          poll: props.poll.id,
          answers: [],
        };

        questions.value.forEach((q) => {
          payload.answers.push({
            question: q.question.id,
            selected_option: q.question.question_type === 1 ? q.answer : null,
            text_answer: q.question.question_type === 2 ? q.answer : null,
          });
        });

        const response = await api.submitPollAnswer(props.poll.id, payload);
        if (response.ok) {
          context.emit("submitted");
        }
        else {
          alert(JSON.stringify(response.data));
        }
      }
    };

    const questions = computed(() => {
      let questionsAnswers = [];

      props.poll.poll_questions.forEach((element) => {
        questionsAnswers.push({
          question: element,
          answer: "",
        });
      });
      return questionsAnswers;
    });

    return {
      questions,
      form,
      submit,
      question_rules,
      getDateTime,
      markdownToHtml,
      icons: {
        mdiCalendarToday,
        mdiEyeOffOutline,
        mdiAccountGroupOutline,
        mdiEyeOutline,
        mdiRestart
      }
    };
  },
};

</script>

<style></style>